import { buildFontFaceRule } from '@utils/font-face-rule';

// Page-scoped @font-face + apply rule for the config's font, like the consent
// UI modal. '' when no custom font is configured (the library font stays).
export const getFeedbackFontFaceRule = (customFont) => buildFontFaceRule({
  weights: customFont?.weights,
  familyName: customFont?.fontName,
  // The language popover renders in a portal, outside the page subtree.
  scopeSelectors: ['.feedback-page', '.feedback-locale-popover'],
});
